import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { Settings } from 'src/app/services/settings';
import { DAO } from '../../modal/DAO'
import { ChangeDetectionService } from '../../services/changeDetectionService';
import { MessageService } from 'primeng/api';
import { ServiceLayer } from 'src/app/services/serviceLayer';
import { MenuClickContext } from 'src/app/modal/routing.models';
import { CommonService } from 'src/app/services/commonService';
import { EndorsementService } from 'src/app/services/endorsement.service';
import { debounceTime, take, takeUntil } from 'rxjs/operators';
import { AppConfig } from 'src/app/app.config';
import { Auth0UserService } from 'src/app/services/auth0UserService.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  public isRegistrationPage: boolean = false;
  public menuName: string = "";
  public environment: string;
  private endorsementRoute: string = '/endorsements/';
  private lastFocusedElement: HTMLElement | null = null;
  constructor(
    public dao: DAO,
    public appComponent: AppComponent,
    public router: Router,
        private setting: Settings,
    public dataChangeService: ChangeDetectionService,
    private messageService: MessageService,
    private serviceLayer: ServiceLayer,
    private endorsementService: EndorsementService,
    private commonService: CommonService,
    private appConfig: AppConfig,
    public auth0UserService: Auth0UserService,) {
       this.environment = this.appConfig.environment;
    }

  ngOnInit(): void {}
    
  GoHome() {
    this.menuName = 'Home';
    
    if (this.router.url.includes(this.endorsementRoute)) {
      this.handleEndorsementNavigation("/home");
      return;
    }
    const menuClickedConext: MenuClickContext = this.detectPageDataChange();
    if (!this.isSubmissionReadOnly() && !!menuClickedConext["hasInvalidPowerUnitAgeInSaveAs"]) {
      this.displayPopupIncaseOfVehicleAge(); //Save as vehilce data cannot be rolled back
    }
    else if (!this.isSubmissionReadOnly() && menuClickedConext.currentPageDataChanged) {
      this.serviceLayer.UpdateFiledsValuesAndValidate(this.dao.PolicySubTemplate);
      this.displayPopupIncaseOfUnsavedDataExists();
    }
    else {
      if (!this.isRegistrationPage) {
        this.dao.PolicyTemplate = '';
        this.dao.PolicySubTemplate = 'newsubmission';
        if (window.location.href.indexOf("/home")<0)        
        
        {
          this.router.navigateByUrl('/home');  
        }
      }
    }
  }

  detectPageDataChange(): MenuClickContext {
    let menuClickContext: MenuClickContext = new MenuClickContext();
    menuClickContext.currentPageIsValid = true;
    menuClickContext.page = this.menuName;
    this.serviceLayer.menuClickBehavior.next(menuClickContext);
    let hasDataChanged = menuClickContext.currentPageDataChanged    
    return menuClickContext;
  }

  confirmNavigate() {
    this.messageService.clear();
    document.body.style.pointerEvents = "visible";
    this.dao.PolicyTemplate = '';
    if (this.menuName == 'Home') {
      if (!this.isRegistrationPage) {
        this.dao.PolicyTemplate = '';
        this.dao.PolicySubTemplate = 'newsubmission';
        this.router.navigateByUrl('/home');
      }
    }
    else if (this.menuName == 'UserAdmin') {
      this.router.navigateByUrl('/userManagement');
    }
    else if (this.menuName == 'InternalAdmin') {
      this.router.navigateByUrl('/internalAdmin');
    }
  }

  onReject() {
    this.messageService.clear('homeUserAdmin');
    document.body.style.pointerEvents = "visible";
    if (this.lastFocusedElement) {
      this.lastFocusedElement.focus();
      this.lastFocusedElement = null;
    }
  }

  displayPopupIncaseOfUnsavedDataExists() {
    this.dao.NotAllowedToSubmit = false;
    this.dao.IsSavedFromMenu = false;
    this.dao.isEmptyListFromMenu = true;
    document.body.style.pointerEvents = "none";
    this.lastFocusedElement = document.activeElement as HTMLElement;
    this.messageService.add({ key: 'homeUserAdmin', sticky: true, severity: 'warn', summary: "If you leave this page without saving, your data will be lost. Are you sure you want to leave this page?" });
  }

  displayPopupIncaseOfVehicleAge() {
    this.dao.NotAllowedToSubmit = false;
    this.dao.IsSavedFromMenu = false;
    this.dao.isEmptyListFromMenu = true;
    document.body.style.pointerEvents = "none";
    this.lastFocusedElement = document.activeElement as HTMLElement;
    this.messageService.add({ key: 'homeUserAdmin', sticky: true, severity: 'warn', summary: "If you leave this page, your submission will be declined because of vehicle age profile. Are you sure you want to leave this page?" });
  }

  RedirecTouserAdmin() {
    this.menuName = 'UserAdmin';

    if (this.router.url.includes(this.endorsementRoute)) {
      this.handleEndorsementNavigation("/userManagement");
      return;
    }
    const menuClickedConext: MenuClickContext = this.detectPageDataChange();
    if (!this.isSubmissionReadOnly() && !!menuClickedConext["hasInvalidPowerUnitAgeInSaveAs"]) {
      this.displayPopupIncaseOfVehicleAge();     //Save as vehilce data cannot be rolled back
    }
    else if (!this.isSubmissionReadOnly() && menuClickedConext.currentPageDataChanged) {
      this.displayPopupIncaseOfUnsavedDataExists();
    }
    else {
      this.router.navigateByUrl('/userManagement');
    }
  }

  redirecToInternalAdmin() {
    this.menuName = 'InternalAdmin';

    if (this.router.url.includes(this.endorsementRoute)) {
      this.handleEndorsementNavigation("/internalAdmin");
      return;
    }
    const menuClickedConext: MenuClickContext = this.detectPageDataChange();
    if (!this.isSubmissionReadOnly() && !!menuClickedConext["hasInvalidPowerUnitAgeInSaveAs"]) {
      this.displayPopupIncaseOfVehicleAge();     //Save as vehicle data cannot be rolled back
    }
    else if (!this.isSubmissionReadOnly() && menuClickedConext.currentPageDataChanged) {
      this.displayPopupIncaseOfUnsavedDataExists();
    }
    else {
      this.router.navigateByUrl('/internalAdmin');      
    }
  }
  
  handleEndorsementNavigation(hrefPath: string): void {
    // create MenuClickContext and let endorsement components update currentPageIsValid
    let menuClickContext: MenuClickContext = new MenuClickContext();
    menuClickContext.currentPageIsValid = true;
    menuClickContext.page = this.menuName;
    this.endorsementService.menuClickBehavior.next(menuClickContext);

    // listen for updated menuClickContext from endorsement components and determine how to navigate
    this.endorsementService.menuClickBehavior
    .pipe(debounceTime(100), take(1))
    .subscribe((menuClickContext: MenuClickContext) => {
      if (menuClickContext.currentPageIsValid && !menuClickContext.currentPageDataChanged) {
        this.router.navigateByUrl( hrefPath); 
      } else {
        document.body.style.pointerEvents = "none";
        this.lastFocusedElement = document.activeElement as HTMLElement;
        this.messageService.add({ key: 'homeUserAdmin', sticky: true, severity: 'warn', summary: "If you go back, any data entered will be lost. Are you sure you want to go back?" });
      }
    });
  }

  public get auth0LoggedIn(): boolean{
    return !!this.auth0UserService?.auth0User?.expireAt
  }

  public gotoBop() {    
    window.location.href=this.appConfig.bopApiAuthLoginUrl;
  }

  private isSubmissionReadOnly(): boolean {
    return !!document.querySelector('.nfp-readonly-group');
  }
}
